import React, { useState } from 'react';
import Button from '../../components/bootstrap/Button';
import Card, {
    CardHeader,
    CardBody,
    CardFooter,
    CardFooterLeft,
} from '../../components/bootstrap/Card';
import Page from '../../layout/Page/Page';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import ImageUploading from 'react-images-uploading';
import { InfoCircle } from '../../components/icon/bootstrap';

type TTabs =
    | 'Personal Settings'
    | 'Access Settings'
    | 'My Accounts'
    | 'Billing & Plan';
interface ITabs {
    [key: string]: TTabs;
}

const Profile = () => {
    const [profileImage, setProfileImage] = useState([]);
    const changeProfilePicture = (image: any) => {
        setProfileImage(image);
    };
    const TABS: ITabs = {
        PERSONAL_SETTINGS: 'Personal Settings',
        ACCESS_SETTINGS: 'Access Settings',
        MY_ACCOUNTS: 'My Accounts',
        BILLING_PLAN: 'Billing & Plan',
    };
    const [activeTab, setActiveTab] = useState<TTabs>(TABS.PERSONAL_SETTINGS);
    return (
        <PageWrapper title='Profile'>
            <Page>
                <div className='row'>
                    <div className='col-xl-3 col-lg-4 col-md-6'>
                        <Card stretch className='profile-leftcard'>
                            <CardHeader className='personal-settings-card-header'>
                                <div>
                                    <h5 className='card-heading'>
                                        Account Settings
                                    </h5>
                                    <p style={{ marginBottom: '0px' }}>
                                        Personal Information
                                    </p>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <div className='row g-3'>
                                    <div className='col-12'>
                                        <Button
                                            color='dark'
                                            isLink
                                            className='w-100'
                                            style={{
                                                textAlign: 'left',
                                            }}
                                            onClick={() =>
                                                setActiveTab(
                                                    TABS.PERSONAL_SETTINGS,
                                                )
                                            }>
                                            {TABS.PERSONAL_SETTINGS}
                                        </Button>
                                    </div>
                                    <div className='col-12'>
                                        <Button
                                            color='dark'
                                            isLink
                                            className='w-100'
                                            style={{
                                                textAlign: 'left',
                                            }}
                                            onClick={() =>
                                                setActiveTab(
                                                    TABS.ACCESS_SETTINGS,
                                                )
                                            }>
                                            {TABS.ACCESS_SETTINGS}
                                        </Button>
                                    </div>
                                    <div className='col-12'>
                                        <Button
                                            color='dark'
                                            isLink
                                            className='w-100'
                                            style={{
                                                textAlign: 'left',
                                            }}
                                            onClick={() =>
                                                setActiveTab(TABS.MY_ACCOUNTS)
                                            }>
                                            {TABS.MY_ACCOUNTS}
                                        </Button>
                                    </div>
                                    <div className='col-12'>
                                        <Button
                                            color='dark'
                                            isLink
                                            className='w-100'
                                            style={{
                                                textAlign: 'left',
                                            }}
                                            onClick={() =>
                                                setActiveTab(TABS.BILLING_PLAN)
                                            }>
                                            {TABS.BILLING_PLAN}
                                        </Button>
                                    </div>
                                </div>
                            </CardBody>
                            <CardFooter>
                                <CardFooterLeft className='w-100'>
                                    <p style={{ marginBottom: '5px' }}>
                                        Not interested in Liiftsocial?{' '}
                                    </p>
                                    <a href='/#' style={{ color: 'red' }}>
                                        Deactivate your account
                                    </a>
                                </CardFooterLeft>
                            </CardFooter>
                        </Card>
                    </div>
                    <div className='col-xl-9 col-lg-8 col-md-6'>
                        {TABS.PERSONAL_SETTINGS === activeTab && (
                            <Card
                                stretch
                                tag='form'
                                className='personal-settings-card'>
                                <CardHeader className='personal-settings-card-header'>
                                    <div>
                                        <h5 className='card-heading'>
                                            Account Details
                                        </h5>
                                        <p style={{ marginBottom: '0px' }}>
                                            Set Up Your Account Information
                                        </p>
                                    </div>
                                    <Button color='primary'>Save</Button>
                                </CardHeader>
                                <CardBody className='personal-settings-card-body'>
                                    <div className='personal-settings-avatar'>
                                        <ImageUploading
                                            value={profileImage}
                                            onChange={changeProfilePicture}
                                            maxNumber={1}
                                            dataURLKey='data_url'>
                                            {({ imageList, onImageUpload }) => (
                                                <div className='change-avatar'>
                                                    <div className='avatar-list'>
                                                        <div
                                                            className='avatar-circle'
                                                            onClick={
                                                                onImageUpload
                                                            }>
                                                            <img
                                                                src={require('../../assets/upload-icon.png')}
                                                                width='20'
                                                                alt='Upload Icon'
                                                            />
                                                        </div>
                                                        <div className='avatar-circle-uploaded'>
                                                            {imageList.map(
                                                                (
                                                                    image,
                                                                    index,
                                                                ) => (
                                                                    <div
                                                                        key={
                                                                            index
                                                                        }
                                                                        className='profile-img'>
                                                                        <img
                                                                            src={
                                                                                image.data_url
                                                                            }
                                                                            alt='Profile'
                                                                        />
                                                                    </div>
                                                                ),
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className='avatar-info'>
                                                        <p
                                                            style={{
                                                                marginBottom:
                                                                    '0px',
                                                                fontWeight:
                                                                    '600',
                                                            }}>
                                                            You can change the
                                                            avatar you have set
                                                            for
                                                            fenil@roundtechsquare.com
                                                        </p>
                                                        <p
                                                            style={{
                                                                color: 'rgb(176, 182, 183)',
                                                                marginBottom:
                                                                    '0px',
                                                            }}>
                                                            Click on the cloud
                                                            icon to change the
                                                            avatar
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </ImageUploading>
                                    </div>
                                    <form>
                                        <div className='row'>
                                            <div className='col-xl-6 col-sm-12'>
                                                <div className='mt-4'>
                                                    <label
                                                        htmlFor='name'
                                                        className='mb-1'>
                                                        Name
                                                    </label>
                                                    <input
                                                        type='text'
                                                        className='custom-form-control'
                                                        placeholder='John Doe'
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-xl-6 col-sm-12'>
                                                <div className='mt-4'>
                                                    <label
                                                        htmlFor='email'
                                                        className='mb-1'>
                                                        Email
                                                    </label>
                                                    <input
                                                        type='email'
                                                        className='custom-form-control'
                                                        placeholder='johndoe@gmail.com'
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-xl-6 col-sm-12'>
                                                <div className='mt-3'>
                                                    <label
                                                        htmlFor='initials'
                                                        className='mb-1'>
                                                        Initials
                                                    </label>
                                                    <input
                                                        type='email'
                                                        className='custom-form-control'
                                                        placeholder='JD'
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-xl-6 col-sm-12'>
                                                <div className='mt-3'>
                                                    <label
                                                        htmlFor='initials'
                                                        className='mb-1'>
                                                        Initials
                                                    </label>
                                                    <select
                                                        id='country'
                                                        className='custom-form-control'>
                                                        <option value=''>
                                                            Select Country
                                                        </option>
                                                        <option>Andorra</option>
                                                        <option>
                                                            Afghanistan
                                                        </option>
                                                        <option>
                                                            Anguilla
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        )}
                        {TABS.ACCESS_SETTINGS === activeTab && (
                            <Card
                                stretch
                                tag='form'
                                className='personal-settings-card'>
                                <CardHeader className='personal-settings-card-header'>
                                    <div>
                                        <h5 className='card-heading'>
                                            Access Settings
                                        </h5>
                                        <p style={{ marginBottom: '0px' }}>
                                            Manage your Account Privacy
                                        </p>
                                    </div>
                                    <Button color='primary'>Save</Button>
                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <div className='row'>
                                            <div className='col-xl-6 col-sm-12'>
                                                <div>
                                                    <label
                                                        htmlFor='current-password'
                                                        className='mb-1'>
                                                        Current Password
                                                    </label>
                                                    <input
                                                        type='password'
                                                        className='custom-form-control'
                                                        placeholder='********'
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-xl-6 col-sm-12'>
                                                <div>
                                                    <label
                                                        htmlFor='new-password'
                                                        className='mb-1'>
                                                        New Password
                                                    </label>
                                                    <input
                                                        type='password'
                                                        className='custom-form-control'
                                                        placeholder='******'
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-xl-6 col-sm-12'>
                                                <div className='mt-3'>
                                                    <label
                                                        htmlFor='verify-password'
                                                        className='mb-1'>
                                                        Verify New Password
                                                    </label>
                                                    <input
                                                        type='password'
                                                        className='custom-form-control'
                                                        placeholder='*******'
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </CardBody>
                            </Card>
                        )}
                        {TABS.MY_ACCOUNTS === activeTab && (
                            <Card stretch className='connected-card'>
                                <CardHeader className='personal-settings-card-header'>
                                    <div>
                                        <h5 className='card-heading'>
                                            Accounts Connected
                                        </h5>
                                        <p style={{ marginBottom: '0px' }}>
                                            Social Media Accounts connected with
                                            Liiftsocial
                                        </p>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <div className='row'>
                                        <div className='col-xl-4 col-sm-12'>
                                            <div
                                                className='platform-card-modal'
                                                style={{
                                                    borderTop:
                                                        '5px solid #217BEE',
                                                }}>
                                                <div className='platform-name-modal'>
                                                    <div className='account-left'>
                                                        <div className='user-profile'>
                                                            <h5>DS</h5>
                                                        </div>
                                                        <div
                                                            className='account-details'
                                                            style={{
                                                                textAlign:
                                                                    'left',
                                                            }}>
                                                            <p className='account-name'>
                                                                <img
                                                                    src={require('../../assets/facebook.png')}
                                                                    width='15'
                                                                    style={{
                                                                        marginRight:
                                                                            '5px',
                                                                    }}
                                                                    alt='Facebook'
                                                                />
                                                                Test
                                                            </p>
                                                            <p className='account-type'>
                                                                Facebook Page
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        )}
                        {TABS.BILLING_PLAN === activeTab && (
                            <Card stretch className='billing-card'>
                                <CardHeader className='personal-settings-card-header'>
                                    <div>
                                        <h5 className='card-heading'>
                                            Billing &amp; Plan
                                        </h5>
                                        <p style={{ marginBottom: '0px' }}>
                                            Set Up Your Account Information
                                        </p>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    <div className='trial-note'>
                                        <div
                                            className='d-flex'
                                            style={{ alignItems: 'center' }}>
                                            <InfoCircle />
                                            <p
                                                style={{
                                                    marginBottom: '0px',
                                                    marginLeft: '10px',
                                                }}>
                                                You have 17 days remaining in
                                                your free trial of Liiftsocial.
                                            </p>
                                        </div>
                                    </div>
                                    <div className='subscription-details mt-4'>
                                        <table className='subscription-table'>
                                            <thead>
                                                <th style={{ width: '25%' }}>
                                                    Item
                                                </th>
                                                <th style={{ width: '35%' }}>
                                                    Details
                                                </th>
                                                <th style={{ width: '25%' }}>
                                                    Monthly Total
                                                </th>
                                                <th
                                                    style={{
                                                        width: '25%',
                                                        textAlign: 'end',
                                                    }}>
                                                    Actions
                                                </th>
                                            </thead>
                                            <tbody>
                                                <tr className='border-row'>
                                                    <td
                                                        style={{
                                                            fontWeight: '600',
                                                        }}>
                                                        Standard Plan
                                                    </td>
                                                    <td>$9.99 per month</td>
                                                    <td>$9.99</td>
                                                    <td
                                                        style={{
                                                            textAlign: 'end',
                                                        }}>
                                                        <a href='/subscription'>
                                                            Update
                                                        </a>
                                                    </td>
                                                </tr>
                                                <tr className='border-row'>
                                                    <td
                                                        style={{
                                                            fontWeight: '600',
                                                        }}>
                                                        Users
                                                    </td>
                                                    <td>
                                                        1 included with plan
                                                    </td>
                                                    <td>-</td>
                                                    <td></td>
                                                </tr>
                                                <tr className='border-row'>
                                                    <td
                                                        style={{
                                                            fontWeight: '600',
                                                        }}>
                                                        Social Profiles
                                                    </td>
                                                    <td>
                                                        8 included with plan
                                                    </td>
                                                    <td>-</td>
                                                    <td></td>
                                                </tr>
                                                <tr className='border-row'>
                                                    <td
                                                        style={{
                                                            fontWeight: '600',
                                                        }}>
                                                        Total
                                                    </td>
                                                    <td>Paid monthly</td>
                                                    <td>
                                                        <strong>$9.99</strong>
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        )}
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default Profile;
